import { withFormik } from "formik"
import moment from "moment"
import * as Yup from "yup"
import PagoForm from "./form"

const validationSchema = (t: $TSMigrationFixMe) =>
  Yup.object().shape({
    importe: Yup.number()
      .required(t("errors.importRequired"))
      .typeError(t("errors.numericValue")),
    fecha: Yup.date()
      .required(t("errors.dateRequired"))
      .max(moment(new Date()), t("errors.previousDateCurrent")),

    descripcion: Yup.string().nullable(),
    empresaId: Yup.string().required(t("errors.selectedOnePlease")),
    concepto: Yup.string().required(t("errors.selectedOnePlease")),
    cuentaContableEmpresaId: Yup.string().required(
      t("errors.selectedOnePlease")
    ),
    interes: Yup.object().shape({
      importe: Yup.number()
        .required(t("errors.taxRequired"))
        .typeError(t("errors.numericValue"))
        .nullable(),
      cuentaContableEmpresaId: Yup.string()
        .nullable()
        .when("importe", {
          is: (importe: $TSMigrationFixMe) => importe > 0,
          then: Yup.string().required(t("errors.selectedOnePlease")).nullable(),
          otherwise: Yup.string().nullable(),
        })
        .nullable()
        .typeError(""),
    }),
    periodoAmortizacion: Yup.number().required(t("errors.periodRequired")),
    tipoPrestamo: Yup.number(),
    duracion: Yup.number().nullable(),
    camposPersonalizados: Yup.array().of(
      Yup.object().shape({
        clave: Yup.string().required(t("errors.nameEmpty")),
        valor: Yup.string().required(t("errors.valueEmpty")),
      })
    ),
    comisiones: Yup.array().nullable(),
    cuentaBancaria: Yup.object()
      .shape({
        bic: Yup.string(),
        cuentaIdExterno: Yup.string().required(t("errors.selectedOnePlease")),
        iban: Yup.string(),
      })
      .nullable(),
    tipoImporteAmortizacion: Yup.number().nullable(),
  })

const validateDuracion = (
  t: $TSMigrationFixMe,
  { importeAmortizacion, duracion, isIndefinido }: $TSMigrationFixMe
) => {
  const errors = {}

  if (isIndefinido && !(importeAmortizacion >= 0)) {
    // @ts-expect-error TS(2339): Property 'duracion' does not exist on type '{}'.
    errors.duracion = ""
    // @ts-expect-error TS(2339): Property 'importeAmortizacion' does not exist on t...
    errors.importeAmortizacion = `${t("errors.amortizationLabel")}`
  } else if (!isIndefinido && !duracion) {
    // @ts-expect-error TS(2339): Property 'duracion' does not exist on type '{}'.
    errors.duracion = `${t("errors.durationLabel")}`
    // @ts-expect-error TS(2339): Property 'importeAmortizacion' does not exist on t...
    errors.importeAmortizacion = ""
  }

  return errors
}

const NewPrestamoForm = withFormik({
  validateOnChange: true,
  validateOnBlur: true,
  // @ts-expect-error TS(2339): Property 't' does not exist on type '{}'.
  validate: (rowData, { t }) => validateDuracion(t, rowData),
  // @ts-expect-error TS(2339): Property 'data' does not exist on type '{}'.
  mapPropsToValues: ({ data, tipoPrestamo }) => {
    return {
      importe: data?.importe || "",
      fecha: moment(data?.fecha).format("YYYY-MM-DD"),
      descripcion: data?.descripcion || null,
      periodoAmortizacion: data?.periodoAmortizacion || 1,
      concepto: data?.concepto || "",
      empresaContactoId: data?.contactoId || "",
      cuentaContableEmpresaId: data?.cuentaContableEmpresaId || "",
      interes:
        data?.interes !== null
          ? {
              importe: data?.interes?.importe,
              cuentaContableEmpresaId: data?.interes?.cuentaContableEmpresaId,
            }
          : {
              importe: 0,
              cuentaContableEmpresaId: null,
            },
      tipoPrestamo: data?.tipoPrestamo || tipoPrestamo || "",
      duracion: data?.duracion || null,
      importeAmortizacion:
        data?.duracion > 0
          ? null
          : data?.importeAmortizacion !== null
          ? data?.importeAmortizacion !== undefined
            ? data?.importeAmortizacion
            : null
          : null,
      empresaId: data?.empresaId || "",
      camposPersonalizados: data?.camposPersonalizados || [],
      comisiones: data?.comisiones || [],
      cuentaBancaria: data?.cuentaBancaria || {
        bic: "",
        cuentaIdExterno: "",
        iban: "",
      },
      tipoImporteAmortizacion: data?.tipoImporteAmortizacion || null,
    }
  },
  validationSchema: ({ t }: $TSMigrationFixMe) => validationSchema(t),

  handleSubmit: async (values, { props }) => {
    const camposPersonalizados = values.camposPersonalizados.map(
      ({ clave, valor }: $TSMigrationFixMe) => ({ clave, valor })
    )
    const comisiones = values.comisiones.map(
      (campo: $TSMigrationFixMe) => campo.originalObject || campo
    )
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { importeAmortizacion, ...rest } = values

    const modifiedValues = {
      ...rest,
      comisiones,
      camposPersonalizados,
      importeAmortizacion: values.importeAmortizacion || 0,
      tipoImporteAmortizacion:
        values.duracion === null ? values.tipoImporteAmortizacion : 1,
      cuentaBancariaId: values.cuentaBancaria?.entidadBancariaId,
    }

    if (values.duracion) {
      delete modifiedValues.importeAmortizacion
    }

    // @ts-expect-error TS(2339): Property 'isIndefinido' does not exist on type '{ ...
    delete modifiedValues.isIndefinido
    // @ts-expect-error TS(2339): Property 'handleSubmitPrestamo' does not exist on ...
    props.handleSubmitPrestamo(modifiedValues)
  },
})(PagoForm)

export default NewPrestamoForm
